import { useTranslation } from 'react-i18next';

import * as St from './MinimumPurchaseNotification.style';

import { useAppSelector } from '~/redux/hooks';
import { selectValidSmallTicketNumber } from '~/redux/slices/estimate';

export const MinimumPurchaseNotification = (args: {
  useMinQtyAreaForPricing?: boolean;
  smallJobMinimumArea: number;
}) => {
  const validatedTicketNumber = useAppSelector(selectValidSmallTicketNumber);
  const { useMinQtyAreaForPricing = false, smallJobMinimumArea } = args;
  const { t } = useTranslation();

  return (
    <>
      {useMinQtyAreaForPricing && (
        <div>
          {t('PRICING_AREA.MINIMUM_PURCHASE_NOTE', {
            sqft: smallJobMinimumArea,
          })}
        </div>
      )}
      {validatedTicketNumber && (
        <div>
          {`${t('SMALL_PROJECTS.PRODUCT_NOTE.DESCRIPTION')}: `}
          <St.TicketNumber>{validatedTicketNumber}</St.TicketNumber>
        </div>
      )}
    </>
  );
};
